import { Dispatch, ReactElement, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { AddNewLeadsIconSvg, TotalBookingsIconSvg, TotalEnquiriesIconSvg, TotalPendingsIconSvg, TotalQuotationsIconSvg } from "../../assets/svg";
import React from "react";
interface IAnalyticItem { 
    count: string;
    icon: ReactElement;
    label: string;
    route: string;
    isActive: boolean;
}
interface IAnalyticBoxProps {
    item: IAnalyticItem,
    setAnalyticBoxData: Dispatch<SetStateAction<any>>,
    setSelectedTab: Dispatch<SetStateAction<string>>,
}

const AnalyticBox: React.FC<IAnalyticBoxProps> = (props) => {
    const { item : {count, icon, label, route = '/', isActive }, setAnalyticBoxData, setSelectedTab } = props;
    const navigate = useNavigate();

    const handleAnalyticBoxClick = (route: string) => {
      // setAnalyticBoxData((prevState: IAnalyticItem[]) => {
      //   const updatedData = prevState.map((item: IAnalyticItem) => {
      //     const fillColor = item.route === route ? "#fff" : "#3a3a3a";
      //     return {
      //       ...item,
      //       icon: React.cloneElement(item.icon, { fill: fillColor }),
      //       isActive: item.route === route,
      //     };
      //   });
      //   return updatedData;
      // });

      ["enquiry", "quotation", "booking"].includes(route) ? setSelectedTab(route) : navigate(route);
    };
      
    return (
        <div className="w-100 h-[167px] flex flex-col justify-between rounded border bg-[#ffffff] p-3 shadow mx-auto cursor-pointer" style={{
            background: isActive ? "linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%)" : ""}}
            onClick={() => handleAnalyticBoxClick(`${route}`)}
        >
            {icon}
            <div className="self-end flex flex-col gap-0.5">
                <p className="m-0 w-fit self-end" style={{ fontSize: "64px", fontWeight: "700", lineHeight: "64px", color: isActive ? "#ffffff" : "" }}>{count}</p>
                <p className=" w-fit font-weight-bold m-0 text-nowrap" style={{ fontSize: "16px", fontWeight: "500", lineHeight: "16px", color: isActive ? "#ffffff" : "" }}>{label}</p>
            </div>
        </div>
    )
}
export default AnalyticBox